import type { JSX } from 'react'
import { illustrationColors } from './shared'

export function RoofRack(): JSX.Element {
  return (
    <g fill={illustrationColors.trim}>
      <rect x="132" y="111" width="136" height="2.6" rx="1.3" />
      {[140, 198, 256].map((x) => (
        <rect key={x} x={x} y="113" width="4" height="3.5" />
      ))}
    </g>
  )
}
